+function($, window) {
  $(function() {
    var elLoginForm = $('.dy-login-form form'),
        elLoginError = $('.dy-login-error'),
        elLoginBtn = elLoginForm.find('.btn'),
        elPhone = elLoginForm.find('input[name="username"]'),
        elPhoneError = elLoginForm.find('.username-error'),
        elPassword = elLoginForm.find('input[name="password"]'),
        elPasswordError = elLoginForm.find('.password-error'),
        elCsrf = elLoginForm.find('input[name="_csrf"]');
    
    //手机号输入检查
    elPhone.on('keyup', $.debounce(250, function() {
      if (elPhone.val()) {
        elPhone.removeClass('error');
        elPhoneError.addClass('hide'); 
      }else {
        elPhone.addClass('error');
        elPhoneError.removeClass('hide'); 
      }
    })); 

    //密码输入检查
    elPassword.on('keyup', $.debounce(250, function() {
      if (elPassword.val()) {
        elPassword.removeClass('error');
        elPasswordError.addClass('hide'); 
      }else {
        elPassword.addClass('error');
        elPasswordError.removeClass('hide'); 
      }
    }));  

    //提交检查
    elLoginForm.on('submit', function(event) {
      event.preventDefault();

      if ( ! isValidAccount()) return false;

      //防止反复点击提交
      if (elLoginBtn.hasClass('disabled')) {
        return false;
      }

      elLoginBtn.text('正在登录...').addClass('disabled');

      var promise = $.post('/login', {
        username: elPhone.val(),
        password: elPassword.val(),
        _csrf: elCsrf.val()
      });

      promise.done(function(res) {
        if (res.code == 200) {
          window.location = '/';
        }else {
          elLoginError.html(res.msg);
        }
      });

      promise.always(function() {
        elLoginBtn.text('登录').removeClass('disabled');
      });

      return false;
    });

    //检查输入是否正确
    function isValidAccount() {
      var valid = true;

      if ( ! elPhone.val()) {
        elPhone.addClass('error');
        elPhoneError.removeClass('hide'); 

        valid = false;
      }else {
        elPhone.removeClass('error');
        elPhoneError.addClass('hide'); 

        valid = true;
      }

      if ( ! elPassword.val()) {
        elPassword.addClass('error');
        elPasswordError.removeClass('hide'); 

        valid = false;
      }else {
        elPhone.removeClass('error');
        elPasswordError.addClass('hide'); 

        valid = true; 
      }

      return valid;
    }
  });
}(jQuery, window);